import React, { useEffect } from 'react';
import { FormFields } from '~/components/FormFields';
import { useTranslation } from 'react-i18next';
import WYSIWYGEditor from '~/components/WYSWYGEditor';
import Attachments from './Attachments';
import { useFormContext } from 'react-hook-form';
import { LanguageType } from '~/api/services/auth';

interface Props {
  language: LanguageType
  languageIndex: number
}

const LangTab:React.FC<Props> = ({ language, languageIndex }): JSX.Element => {
  const { t } = useTranslation();
  const { control, setValue, watch } = useFormContext()
  const watchDraft = watch('isDraft')

  useEffect(() => {
    setValue(`languages[${languageIndex}].id`, language.id);
  }, [languageIndex]);

  return (
    <>
      <FormFields.Input
        label={t('Subject')}
        placeholder={t('Subject')}
        control={control}
        rules={watchDraft === 0 && {
          required: {
            value: true,
            message: t('Please enter subject')
          },
          maxLength: {
            value: 100,
            message: t('Max number of characters is 100')
          }
        }}
        name={`languages[${languageIndex}].subject`}
      />
      <FormFields.External
        name={`languages[${languageIndex}].content`}
        label={t('Content')}
        rules={watchDraft === 0 && {
          required: {
            value: true,
            message: t('Please enter content')
          },
          maxLength: {
            value: 3000,
            message: t('Max number of characters is 3000')
          }
        }}
        control={control}
        tag='textarea'
      >
        <WYSIWYGEditor maxLength={3000} />
      </FormFields.External>
      <Attachments
        languageIndex={languageIndex}
      />
    </>);
};

export default LangTab;
